<script setup lang="ts">
const props = defineProps<{
  items?: { name: string, slug: string, id: string, path: string }[]
}>()

const { t } = useI18n()

const maxLength = 25

const trimmedItems = computed(() => [{ name: '', slug: 'home', id: 'home', path: '/' }, ...(props.items ?? [])].map((item) => {
  const endIndex = item.name.lastIndexOf(' ', maxLength)
  return {
    ...item,
    name: item.name.length > maxLength
      ? `${item.name.slice(0, endIndex > 0 ? endIndex : maxLength).trim()}…`
      : item.name,
  }
}).filter(item => item.name !== '__root_collection__') || [],
)
</script>

<template>
  <nav :aria-label="t('breadcrumb.label')">
    <ol role="list" class="flex items-center overflow-x-auto no-scrollbar -ml2">
      <template v-if="trimmedItems?.length">
        <li
          v-for="(item, index) in trimmedItems"
          :key="index"
          class="ml2"
        >
          <div class="flex items-center">
            <NuxtLinkLocale :to="item.path" class="mr2 text-sm text-slate4 dark:text-slate5" :data-testid="`breadcrumb-${index}`">
              <template v-if="item.id === 'home'">
                <Icon name="i-heroicons:home" />
              </template>
              <template v-else>
                <span class="whitespace-nowrap">
                  {{ item.name }}
                </span>
              </template>
            </NuxtLinkLocale>

            <svg
              v-if="index !== trimmedItems.length - 1" viewBox="0 0 6 20" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
              class="h5 w-auto text-slate4"
            >
              <path d="M4.878 4.34H3.551L.27 16.532h1.327l3.281-12.19z" fill="currentColor" />
            </svg>
          </div>
        </li>
      </template>
      <li v-else>
        <NSkeleton class="w-full" pulse />
      </li>
    </ol>
  </nav>
</template>
